module.exports = __webpack_public_path__ + "img/1488633655.25d50f31.jpg";